export class NotFoundError extends Error {
    params: object;

    constructor(message: string, params: object = {}) {
        super(message);

        this.params = params;
    }
}

export class ServerError extends Error {
    params: object;

    constructor(message: string, params: object = {}) {
        super(message);

        this.params = params;
    }
}
